import React from "react";
import { Box, Container, Typography, Stack, Link } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Link as ScrollLink } from "react-scroll"; // Import ScrollLink from react-scroll

const Footer = () => {
  return (
    <Box sx={{ bgcolor: "#1D1C22", color: "#fff", py: 4, mt: 6 }}>
      <Container>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={3}
          justifyContent="space-between"
          alignItems="flex-start"
          textAlign={{ xs: "left", sm: "left" }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6">Karen Brown</Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              CDC Certified Divorce Coach® & Advisor, serving clients virtually across the U.S.
            </Typography>
          </Box>

          <Box sx={{ flex: 1, pl: { xs: 0, sm: 6 } }}>
            <Typography variant="h6">Quick Links</Typography>
            <Stack spacing={1} sx={{ mt: 1 }}>
              <ScrollLink to="about" smooth={true} duration={500}>
                <Link href="#about" color="inherit" underline="hover">About</Link>
              </ScrollLink>
              <ScrollLink to="services" smooth={true} duration={500}>
                <Link href="#services" color="inherit" underline="hover">Services</Link>
              </ScrollLink>
              <ScrollLink to="for law firms" smooth={true} duration={500}>
                <Link href="#for law firms" color="inherit" underline="hover">For Law Firms</Link>
              </ScrollLink>
              <ScrollLink to="contact" smooth={true} duration={500}>
                <Link href="#contact" color="inherit" underline="hover">Contact</Link>
              </ScrollLink>
            </Stack>
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography variant="h6">Contact</Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Email: <Link href="mailto:karenbrowndivorceadvising@gmail.com" color="inherit">karenbrowndivorceadvising@gmail.com</Link>
            </Typography>
            <Typography variant="body2">Phone: (201) 355-6718</Typography>

            <Box sx={{ display: "flex", flexDirection: "column", mt: 1, gap: 1 }}>
              {/* LinkedIn */}
              <Link
                href="https://www.linkedin.com/in/karenbrowndivorceadvising/"
                target="_blank"
                rel="noopener"
                sx={{ color: "inherit", display: "flex", alignItems: "center" }}
              >
                <LinkedInIcon sx={{ fontSize: 22, mr: 0.5 }} />
                <Typography variant="body2">LinkedIn</Typography>
              </Link>

              {/* Facebook */}
              <Link
                href="https://www.facebook.com/KBDivorceCoach"
                target="_blank"
                rel="noopener"
                sx={{ color: "inherit", display: "flex", alignItems: "center" }}
              >
                <FacebookIcon sx={{ fontSize: 22, mr: 0.5 }} />
                <Typography variant="body2">Facebook</Typography>
              </Link>

              {/* Instagram */}
              <Link
                href="https://www.instagram.com/kbdivorcecoach"
                target="_blank"
                rel="noopener"
                sx={{ color: "inherit", display: "flex", alignItems: "center" }}
              >
                <InstagramIcon sx={{ fontSize: 22, mr: 0.5 }} />
                <Typography variant="body2">Instagram</Typography>
              </Link>
            </Box>
          </Box>
        </Stack>

        <Typography variant="body2" align="center" sx={{ mt: 4, opacity: 0.7 }}>
          © {new Date().getFullYear()} Karen Brown Divorce Advising LLC. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;